var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c49ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#063b91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cd232e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd232e"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v6.095238h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 8.380952h16v3.047619h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 6.095238h16v2.285714h-16z",
    fill: "url(#a)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 6.857143h16v1h-16z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.0952381 9.9047619c-.21039419 0-.38095239-.17055817-.38095239-.38095238s.1705582-.38095238.38095239-.38095238c.21613635 0 .42685836-.03585592.62622896-.10522644.19870915-.06914034.41584408.03589593.48498442.23460511.06914035.19870918-.03589591.41584404-.23460507.48498438-.27960498.09728785-.57494222.14754171-.87660831.14754171zm2.01995664-.92566377c.19470621-.22572891.35062995-.48263527.46049897-.76033562.07740229-.19563893-.01844739-.41698262-.21408632-.49438499-.19563893-.07740228-.41698263.01844739-.49438499.21408633-.07837539.19809851-.18974507.38159573-.32895998.54299185-.13742016.1593155-.1196705.39986727.03964496.53728739.15931548.13742019.39986717.11967047.53728736-.03964496zm.62241562-2.10215565c-.04036137-.29769847-.13043726-.58406044-.26555154-.84898422-.09558933-.1874257-.32501836-.26187377-.51244412-.16628442-.18742567.09558934-.26187375.32501836-.16628441.51244406.09633325.18888431.16049721.39286914.18928274.60518574.02826621.20848678.22019246.35458437.42867924.32631812.20848678-.02826626.35458438-.2201925.32631809-.42867928zm-1.22779572-1.89975544c-.25241208-.15821182-.52993757-.27331077-.82221734-.33964719-.20517605-.04656719-.40925426.08201071-.45582144.28718676-.04656718.20517606.08201072.40925427.28718677.45582145.20828209.04727214.40607767.12930448.58620816.24221021.17826958.11173931.41336823.05780589.52510753-.12046369.11173936-.17826957.05780587-.41336823-.12046368-.52510754zm-2.13263155-.30786764c-.28832512.08045076-.55998053.20893785-.80454073.37928068-.17264283.12025043-.21511527.35768734-.09486483.53033018.12025043.17264284.35768734.21511526.53033017.09486483.17463773-.12163993.36836614-.21326924.57384612-.2706039.2026531-.05654587.32109641-.26666816.26455053-.46932126-.05654587-.2026531-.26666816-.32109641-.46932126-.26455053zm-1.68209431 1.40551519c-.12981503.26742201-.21421942.55546053-.24875153.85409048-.02416792.20900151.12566932.39802266.33467082.42219057s.39802265-.12566932.42219057-.33467082c.02463764-.21306372.08476289-.41824718.17730589-.60888794.09187872-.18927232.0129256-.41719029-.17634672-.50906902-.18927233-.09187872-.4171903-.0129256-.50906903.17634673zm-.04533365 2.22806796c.11927007.27359345.28382751.52503635.48606037.74401402.14274416.15456335.38375949.16414469.53832281.02140046.15456332-.14274415.16414465-.38375947.02140049-.53832282-.1446437-.15662011-.26223941-.33630575-.3473593-.53156213-.08407721-.19286461-.30858286-.28105418-.50144742-.19697699-.19286457.08407718-.28105415.30858285-.19697695.50144746zm1.63466565 1.47624823c-.20045114-.06391444-.311136-.27822507-.24722156-.47867619s.27822509-.311136.47867623-.24722156c.17456895.05566179.35730204.08592998.5443356.08928975.21036026.00377882.3778276.17737288.37404879.38773311-.00377881.21036022-.17737282.37782758-.38773307.37404876-.26119718-.00469196-.51727733-.04710949-.76210599-.12517387z",
    fill: "#f7d035",
    mask: "url(#e)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/CV.4f7627e20ebc2c41d49247abd538eef7.svg";
export { ForwardRef as ReactComponent };